module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown-container",
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "dropdown padding-reset margin-reset grid-12"
  }, [_c('button', {
    staticClass: "width_full",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.selectedItemOverride || _vm.defaultValue || _vm.defaultText) + " \n      "), _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "dropdown-content row",
    attrs: {
      "id": "myDropdown"
    }
  }, [_c('ul', {
    staticClass: "grid-12"
  }, _vm._l((_vm.values), function(value) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.dropdownItemClick($event, value)
        }
      }
    }, [_vm._v(_vm._s(value.name))])
  }))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4edb2653!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Dropdown.vue
// module id = 368
// module chunks = 2